module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Italic_1.6a8cb980.eot";